// @flow

import React, { Component } from 'react';
import { getHeaderDateFormat } from 'utils/rencontreUtils';
import { shouldUsePlaceholder } from 'utils/assetsUtils';

type Props = {
  id_rencontre: number,
  reception: boolean,
  france_logo: string,
  adversaire_logo: string,
  adversaire: string,
  date_rencontre: string,
  tab: string,
  france_score: number,
  adversaire_score: number,
  france_score_mi_temps: number,
  adversaire_score_mi_temps: number,
  rencontre_terminee: boolean,
}

export default class BannerScoreboard extends Component<Props> {

  render() {
    const {
      id_rencontre,
      reception,
      france_logo,
      adversaire_logo,
      adversaire,
      date_rencontre,
      france_score,
      adversaire_score,
      france_score_mi_temps,
      adversaire_score_mi_temps,
      rencontre_terminee,
    } = this.props;

    const date = new Date().toJSON().slice(0, 10);

    if (rencontre_terminee || (date_rencontre && (date_rencontre < date))) {
      const localHalfTimeScore = reception ? france_score_mi_temps : adversaire_score_mi_temps;
      const visitorHalfTimeScore = reception ? adversaire_score_mi_temps : france_score_mi_temps;
      return (
        <div className="banner__scoreboard">
          <div>
            <span className="banner__scoreboard__image">
              <img
                src={shouldUsePlaceholder(
                  { embleme_adversaire: adversaire_logo, embleme_france: france_logo, reception },
                  true
                )}
                alt={`Logo ${reception ? 'France' : adversaire}`}/>
              </span>
            <h3 className="mt-2 ft-center">{reception ? 'France' : adversaire}</h3>
          </div> 
          <div>
            <div className="banner__scoreboard__score">
              <p className="ft-h2">{reception ? france_score : adversaire_score}</p>
              <p className="ft-h2">:</p>
              <p className="ft-h2">{reception ? adversaire_score : france_score}</p>
            </div>
            {id_rencontre === 94913 && 
            <div>
              <span className="label label--blue-dark mt-3"> Annulé </span>
            </div>}
            {id_rencontre !== 94913 && 
            <h2 className="ft-center ft-up mt-1">{`Mi-temps ${localHalfTimeScore} : ${visitorHalfTimeScore}`}</h2>}
          </div>
          <div>
            <span className="banner__scoreboard__image">
              <img
                src={shouldUsePlaceholder(
                  { embleme_adversaire: adversaire_logo, embleme_france: france_logo, reception },
                  false
                )}
                alt={`Logo ${reception ? adversaire : 'France'}`}/>
              </span>
            <h3 className="mt-2 ft-center">{reception ? adversaire : 'France'}</h3>
          </div>
        </div>
      );
    }

    return (
      <div className="banner__scoreboard">
        <div>
          <span className="banner__scoreboard__image">
            <img
              src={shouldUsePlaceholder(
                { embleme_adversaire: adversaire_logo, embleme_france: france_logo, reception },
                true
              )}
              alt={`Logo ${reception ? 'France' : adversaire}`}/>
          </span>
          <h3 className="mt-2 ft-center">{reception ? 'France' : adversaire}</h3>
        </div>
        {id_rencontre !== 94913 && 
        <div>
          {date_rencontre && getHeaderDateFormat(date_rencontre)}
          <span className="label label--blue-dark mt-3"> À venir </span>
        </div>}
        {id_rencontre === 94913 && 
        <div>
          <span className="label label--blue-dark mt-3"> Annulé </span>
        </div>}
        <div>
          <span className="banner__scoreboard__image">
            <img
              src={shouldUsePlaceholder(
                { embleme_adversaire: adversaire_logo, embleme_france: france_logo, reception },
                false
              )}
              alt={`Logo ${reception ? adversaire : 'France'}`}/>
          </span>
          <h3 className="mt-2 ft-center">{reception ? adversaire : 'France'}</h3>
        </div>
      </div>
    );
  }
}
